// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import AlertError from "@tps/XDL/Icons/AlertError";
import AlertInfo from "@tps/XDL/Icons/AlertInfo";
import AlertSuccess from "@tps/XDL/Icons/AlertSuccess";
import AlertWarning from "@tps/XDL/Icons/AlertWarning";
import Close from "@tps/XDL/Icons/Close";
import { buttonTransparent } from "@tps/XDL/PreStyle/button";
import { xBaseTheme } from "@tps/XDL/types";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                padding: 0;
                margin-top: 6px;
                margin-left: 5px;
                ${buttonTransparent}
                &:hover ${IconWrapper} {
                    color: ${color("common.ui7", 0.33)}!important;
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 10,
            color: "common.ui7",
            css: css`
                &:hover {
                    color: ${color("common.ui7", 0.33)} !important;
                }
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 12px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            color: "text.main",
            css: css`
                    font-size: 14px;
                    font-weight: normal;
                    letter-spacing: 0;
                    line-height: 22px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                display: flex;
                align-items: flex-start;
                padding: 9px 12px 9px 13px;
                justify-content: space-between;
                @media print {
                    display: none;
                }
                ${xScreen("lte", "xs")} {
                    max-width: calc(100% - 30px);
                    margin: 0 15px;
                }
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
